// Which login screen a logged-out (or 401'd) visitor belongs on, derived from the path
// they were on. Each front-end domain serves the same SPA build, so the path is what
// tells the three logins apart:
//   /portal/*  -> app.laxmicablevision.in   (customer portal)
//   /agent/*   -> agent.laxmicablevision.in (collection agent app)
//   everything else -> crm.laxmicablevision.in (staff/admin)
// Without this, a session expiring on app/agent.laxmicablevision.in would drop the user
// on the staff CRM login form.
//
// The /agent test is anchored on a path separator on purpose: `/agent-collection` is the
// ADMIN's agent-management page on the CRM and must keep bouncing to the staff /login.
export const loginPathFor = (pathname = '') => {
  if (/^\/portal(\/|$)/.test(pathname)) return '/portal/login';
  if (/^\/agent(\/|$)/.test(pathname)) return '/agent/login';
  return '/login';
};

export default loginPathFor;
